import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzEsa } from './pages'

type TIdToPageMapWoofzEsa = Record<PageIdWoofzEsa, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_ESA: TIdToPageMapWoofzEsa = {
  [PageIdWoofzEsa.DOG_AGE_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/DogAgeQuestionVariant2'
      ).then((m) => ({
        default: m.DogAgeQuestionVariant2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/DogAgeQuestionVariant2'),
  },
  [PageIdWoofzEsa.MOTIVATION_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/questions/MotivationQuestion').then(
        (m) => ({
          default: m.MotivationQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/MotivationQuestion'),
  },
  [PageIdWoofzEsa.ESA_LETTER]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/urge/EsaLetter').then((m) => ({
        default: m.EsaLetter,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/urge/EsaLetter'),
  },
  [PageIdWoofzEsa.ACCOMPANY_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/questions/AccompanyQuestion').then(
        (m) => ({
          default: m.AccompanyQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/AccompanyQuestion'),
  },
  [PageIdWoofzEsa.HAPPINESS_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/questions/HappinessQuestion').then(
        (m) => ({
          default: m.HappinessQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/HappinessQuestion'),
  },
  [PageIdWoofzEsa.SADNESS_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/questions/SadnessQuestion').then(
        (m) => ({
          default: m.SadnessQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/SadnessQuestion'),
  },
  [PageIdWoofzEsa.TRY_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/questions/TryQuestion').then(
        (m) => ({
          default: m.TryQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/TryQuestion'),
  },
  [PageIdWoofzEsa.FULL_SUPPORT_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/TrainingSupportQuestion'
      ).then((m) => ({
        default: m.TrainingSupportQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/TrainingSupportQuestion'),
  },
  [PageIdWoofzEsa.EXPERT_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/urge/WoofzExpert').then((m) => ({
        default: m.WoofzExpert,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/urge/WoofzExpert'),
  },
  [PageIdWoofzEsa.PERSONALIZED_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/urge/PersonalProgram').then(
        (m) => ({
          default: m.PersonalProgram,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/urge/PersonalProgram'),
  },
  [PageIdWoofzEsa.MENTAL_HEALTH_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/MentalHealthQuestion'
      ).then((m) => ({
        default: m.MentalHealthQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/MentalHealthQuestion'),
  },
  [PageIdWoofzEsa.SADNESS_LAST_WEEKS_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/SadnessLastWeekQuestion'
      ).then((m) => ({
        default: m.SadnessLastWeekQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/SadnessLastWeekQuestion'),
  },
  [PageIdWoofzEsa.ANGER_LAST_WEEKS_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/AngerLastWeekQuestion'
      ).then((m) => ({
        default: m.AngerLastWeekQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/AngerLastWeekQuestion'),
  },
  [PageIdWoofzEsa.WORRY_LAST_WEEKS_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/WorryLastWeekQuestion'
      ).then((m) => ({
        default: m.WorryLastWeekQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/WorryLastWeekQuestion'),
  },
  [PageIdWoofzEsa.AFRAID_LAST_WEEKS_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/AfraidLastWeekQuestion'
      ).then((m) => ({
        default: m.AfraidLastWeekQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/AfraidLastWeekQuestion'),
  },
  [PageIdWoofzEsa.SLEEP_LAST_WEEKS_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/SleepLastWeekQuestion'
      ).then((m) => ({
        default: m.SleepLastWeekQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/SleepLastWeekQuestion'),
  },
  [PageIdWoofzEsa.NERVOUS_LAST_WEEKS_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/NervousLastWeekQuestion'
      ).then((m) => ({
        default: m.NervousLastWeekQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/NervousLastWeekQuestion'),
  },
  [PageIdWoofzEsa.MEMORY_LAST_WEEKS_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/MemoryLastWeekQuestion'
      ).then((m) => ({
        default: m.MemoryLastWeekQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/MemoryLastWeekQuestion'),
  },
  [PageIdWoofzEsa.FOCUS_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/HardToFocusQuestion'
      ).then((m) => ({
        default: m.HardToFocusQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/HardToFocusQuestion'),
  },
  [PageIdWoofzEsa.EMOTIONAL_SCORE_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/urge/EmotionalScore').then((m) => ({
        default: m.EmotionalScore,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/urge/EmotionalScore'),
  },
  [PageIdWoofzEsa.DOG_NOTICE_UPSET_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/DogNoticeUpsetQuestion'
      ).then((m) => ({
        default: m.DogNoticeUpsetQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/DogNoticeUpsetQuestion'),
  },
  [PageIdWoofzEsa.DOG_NEXT_TO_YOU_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/DogNextToYouQuestion'
      ).then((m) => ({
        default: m.DogNextToYouQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/DogNextToYouQuestion'),
  },
  [PageIdWoofzEsa.DOG_SUPPORT_CUES_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/questions/DogSupportCues').then(
        (m) => ({
          default: m.DogSupportCuesQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/DogSupportCues'),
  },
  [PageIdWoofzEsa.STATS_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/urge/StatsEsa').then((m) => ({
        default: m.StatsEsa,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/urge/StatsEsa'),
  },
  [PageIdWoofzEsa.DOG_BREED_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedVariantEsa,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzEsa.DOG_SIZE_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/questions/DogSizeQuestion').then(
        (m) => ({
          default: m.DogSizeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/DogSizeQuestion'),
  },
  [PageIdWoofzEsa.URGE_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePageVariantEsa,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/urge/UrgePage'),
  },
  [PageIdWoofzEsa.PREPARE_FLOW_ESA]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/prepare-flow/PrepareFlowEsa'
      ).then((m) => ({
        default: m.PrepareFlowEsa,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_esa/pages/questions/prepare-flow/PrepareFlowEsa'
      ),
  },
  [PageIdWoofzEsa.PLAN_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/urge/TrainPlan').then((m) => ({
        default: m.TrainPlan,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/urge/TrainPlan'),
  },
  [PageIdWoofzEsa.EMAIL_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/email/EmailEsa').then((m) => ({
        default: m.EmailEsa,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/email/EmailEsa'),
  },
  [PageIdWoofzEsa.SUBSCRIPTIONS_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/subscriptions/Subscriptions').then(
        (m) => ({
          default: m.Subscriptions,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzEsa.CANCEL_OFFER_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/subscriptions/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/subscriptions/CancelOffer'),
  },
  [PageIdWoofzEsa.CHAT_UPSELL_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzEsa.UPSELL_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/upsell/Upsell'),
  },
  [PageIdWoofzEsa.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdWoofzEsa.DOWNLOAD_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/download-app/DownloadApp'),
  },
  // temp unused pages
  [PageIdWoofzEsa.INTRO_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/urge/IntroPageEsa').then((m) => ({
        default: m.IntroPageEsa,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_esa/pages/urge/IntroPageEsa'),
  },
  [PageIdWoofzEsa.YOUR_AGE_ESA]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_esa/pages/questions/YourAgeQuestion').then(
        (m) => ({
          default: m.YourAgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_esa/pages/questions/YourAgeQuestion'),
  },
}
